import { z } from 'zod';
import { isoDateSchema } from '../primitives/branded.js';
import { positivePriceSchema } from '../primitives/numeric.js';
/**
 * Stop-Loss.
 *
 * Immer ein fester Kurs, nie ein berechneter. Das ist eine bewusste Festlegung
 * und keine Vereinfachung aus Bequemlichkeit: Der Kurs ergibt sich aus der
 * Analyse des Charts — Trendlinien, Unterstützungen, Tunnel —, und diese Analyse
 * macht der Mensch. Ein Verfahren, das den Stop automatisch nachzieht, würde eine
 * Entscheidung treffen, die niemand delegieren möchte.
 *
 * Die Anwendung hilft an zwei Stellen: Sie zeigt, wann eine beim Broker
 * hinterlegte Order abläuft, und sie hält fest, wie der Stop über die Zeit
 * nachjustiert wurde.
 *
 * Gesetzt wird er, indem die Stop-Loss-Linie im Chart gezogen wird.
 */
/** Der Stop-Kurs einer Position. `null`, solange keiner festgelegt wurde. */
export const stopLossPriceSchema = positivePriceSchema.nullable();
/**
 * Auswertung gegenüber dem letzten Schlusskurs.
 *
 * Reine Ableitung ohne eigenen Zustand: Abstand und Auslösung ergeben sich aus
 * Stop-Kurs und aktuellem Kurs.
 */
export const stopLossEvaluationSchema = z.object({
    /** Der festgelegte Stop-Kurs, oder null. */
    stopPrice: positivePriceSchema.nullable(),
    /** Schlusskurs, gegen den gerechnet wurde. */
    referenceClose: positivePriceSchema.nullable(),
    /** Handelstag von `referenceClose`. */
    referenceDate: isoDateSchema.nullable(),
    /** Absoluter Abstand `referenceClose − stopPrice`. */
    distanceAbsolute: z.number().finite().nullable(),
    /** Abstand als Anteil von `referenceClose`, in Prozent. */
    distancePercent: z.number().finite().nullable(),
    /** Wahr, sobald der letzte Schlusskurs auf oder unter dem Stop liegt. */
    triggered: z.boolean(),
});
//# sourceMappingURL=stop-loss.js.map